import React from 'react';
import { Loader } from 'Components/Loader';

import './PlainLayout.css';

const PlainLayout = ({ showLoader = true, withBorderRadius = false, children }) => {
  const borderRadius = withBorderRadius ? 'borderRadius' : '';
  return <div className={`plainLayout ${borderRadius}`}>{showLoader ? <Loader /> : children}</div>;
};

export default PlainLayout;
